import React, { ReactNode, Component } from "react";
import { style } from "typestyle";
import { isChrome } from "../utils";

interface ChromeWarningProps {
  children: ReactNode;
}

interface ChromeWarningState {
  browserIsChrome: boolean;
  messageIsVisible: boolean;
}

export default class ChromeWarning extends Component<
  ChromeWarningProps,
  ChromeWarningState
> {
  UNSAFE_componentWillMount() {
    this.setState({
      browserIsChrome: isChrome(),
      messageIsVisible: true,
    });
  }

  handleCloseButtonClick = () => {
    this.setState({
      messageIsVisible: false,
    });
  };

  render() {
    const { children } = this.props;

    return (
      <div className={style({ width: "100%", height: "100%" })}>
        {this.renderMessageBar()}
        <div className={style({ width: "100%", height: "100%" })}>
          {children}
        </div>
      </div>
    );
  }

  renderMessageBar() {
    const { browserIsChrome, messageIsVisible } = this.state;

    if (browserIsChrome || !messageIsVisible) {
      return null;
    }

    return (
      <div
        className={style({
          position: "fixed",
          zIndex: 999999999,
          top: "0",
          left: "0",
          right: "0",
          background: "hsla(55, 85%, 70%, .99)",
          padding: "6px",
          textAlign: "center",
          color: "#333",
          fontSize: "14px",
        })}
      >
        <div
          className={style({
            width: "100%",
            $nest: {
              "& a": {
                textDecoration: "underline",
              },
            },
          })}
        >
          <NotChrome />
        </div>
        <div
          className={style({
            position: "absolute",
            right: "6px",
            top: "0px",
            opacity: 0.65,
            cursor: "pointer",
            lineHeight: "28px",
          })}
          onClick={() => this.setState({ messageIsVisible: false })}
        >
          X
        </div>
      </div>
    );
  }
}

function NotChrome() {
  return (
    <span>
      Your browser is not supported. Please download{" "}
      <a target="_blank" href="https://www.google.com/chrome">
        Google Chrome
      </a>
    </span>
  );
}
